import { useCallback } from 'react';
import styled from '@emotion/styled';
import { mediaQuery, Fonts, Spacings } from '@styles/index';
import useNotifyMe from '../useNotifyMe';
import notificationsType from '../constants';

import {
  Wrapper,
  ButtonWrapper,
  Title,
  NotifiedMeCTAWrapper
} from './WebNotifyMe';

const NotifyMeWrapper = styled(Wrapper)`
  ${mediaQuery.uptoMobile} {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: auto;
    width: 100%;
    background: unset;
    border: none;
    justify-content: space-between;
    margin: ${Spacings.SPACING_0B};
    padding: ${Spacings.SPACING_0B};
  }
`;

const TileWrapper = styled(Title)`
  ${mediaQuery.uptoMobile} {
    font-weight: ${Fonts.SEMIBOLD};
    font-size: ${Fonts.SMALL};
    line-height: ${Spacings.SPACING_18};
    text-align: left;
    width: 150px;
  }
`;

const CTAWrapper = styled(ButtonWrapper)`
  ${mediaQuery.uptoMobile} {
    width: ${({ $width }) => $width};
    display: flex;
    justify-content: flex-end;
    height: 48px;
    button {
      height: 48px;
      font-weight: ${Fonts.HEAVY};
      font-size: ${Fonts.SMALL};
      line-height: ${Spacings.SPACING_18};
      border-radius: ${Spacings.SPACING_2B};
      width: ${({ $width }) => $width};
    }
    svg {
      height: 25px !important;
      width: 25px !important;
    }
  }
`;

const StickyNotifyMe = () => {
  const {
    sendNotifyMeRequest,
    notifiedNotification = {},
    notifyMeInfo,
    isNotifyRequested
  } = useNotifyMe();
  const { onBlock } = notifyMeInfo;
  const isNotified = notifiedNotification[notificationsType.UPCOMING_BATCHES];

  const handleClick = useCallback(() => {
    sendNotifyMeRequest({
      notification_type: notificationsType.UPCOMING_BATCHES,
      is_active: !isNotified,
      touchPoint: 'Page Footer'
    });
  }, [isNotified, sendNotifyMeRequest]);

  return (
    <NotifyMeWrapper>
      <TileWrapper>{onBlock.title}</TileWrapper>
      <CTAWrapper $width={isNotified ? '160px' : '140px'}>
        <NotifiedMeCTAWrapper
          isNotified={isNotified}
          onClick={handleClick}
          isNotifyRequested={isNotifyRequested}
          label="Notify me"
        />
      </CTAWrapper>
    </NotifyMeWrapper>
  );
};
export default StickyNotifyMe;
